import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";

import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import MiHistoria from "@/pages/MiHistoria";
import MetodoTao from "@/pages/MetodoTao";
import Oncologia from "@/pages/Oncologia";
import Fibromialgia from "@/pages/Fibromialgia";
import SesionesOnline from "@/pages/SesionesOnline";
import Prensa from "@/pages/Prensa";
import Contacto from "@/pages/Contacto";
import SesionGratuita from "@/pages/SesionGratuita";
import Testimonios from "@/pages/Testimonios";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import CountryLanding from "@/pages/CountryLanding";
import ProfesionalesSanitarios from "@/pages/ProfesionalesSanitarios";
import Newsletter from "@/pages/Newsletter";
import PreguntasFrecuentes from "@/pages/PreguntasFrecuentes";
import AdminNewsletter from "@/pages/AdminNewsletter";
import Asociaciones from "@/pages/Asociaciones";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mi-historia" element={<MiHistoria />} />
            <Route path="/metodo-tao" element={<MetodoTao />} />
            <Route path="/oncologia" element={<Oncologia />} />
            <Route path="/fibromialgia" element={<Fibromialgia />} />
            <Route path="/sesiones-online" element={<SesionesOnline />} />
            <Route path="/prensa" element={<Prensa />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/sesion-gratuita" element={<SesionGratuita />} />
            <Route path="/testimonios" element={<Testimonios />} />
            <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/asociaciones" element={<Asociaciones />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/yoga-oncologico-mexico" element={<CountryLanding slug="mexico" />} />
            <Route path="/yoga-oncologico-argentina" element={<CountryLanding slug="argentina" />} />
            <Route path="/yoga-oncologico-colombia" element={<CountryLanding slug="colombia" />} />
            <Route path="/yoga-oncologico-chile" element={<CountryLanding slug="chile" />} />
            <Route path="/profesionales" element={<ProfesionalesSanitarios />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
